export const initToc = () => {
  const tocInNavEl = document.querySelector(
    '.md-sidebar--primary nav.md-nav.md-nav--secondary'
  );

  if (tocInNavEl) {
    tocInNavEl.remove();
  }

  const tocMobileLinksEls = document.querySelectorAll(
    '.toc-mobile .md-nav__item .md-nav__link'
  );

  tocMobileLinksEls.forEach((el) => {
    el.classList.add('dropdown-item');

    el.addEventListener('click', () => {
      const htmlEl = document.querySelector('html') as HTMLElement;

      setTimeout(() => {
        htmlEl.scrollTop = htmlEl.scrollTop - 64;
      }, 0);
    });
  });
};
